<script>
import SectionLayout from '../account/components/SectionLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import Policy from 'dashboard/components/policy.vue';
import GlobalNotificationSettings from './GlobalNotificationSettings.vue';

export default {
  components: {
    SectionLayout,
    BaseSettingsHeader,
    Policy,
    GlobalNotificationSettings,
  },
};
</script>

<template>
  <div class="grid max-w-2xl ltr:mr-auto rtl:ml-auto">
    <Policy :permissions="['administrator']">
      <BaseSettingsHeader
        :title="$t('GLOBAL_NOTIFICATION_SETTINGS.TITLE')"
        :description="$t('GLOBAL_NOTIFICATION_SETTINGS.DESCRIPTION')"
      />
      <SectionLayout title="" description="" class="!pt-0">
        <GlobalNotificationSettings />
      </SectionLayout>
    </Policy>
  </div>
</template>
